import { Button, Card, CardHeader, makeStyles, SkeletonItem, Text } from '@fluentui/react-components';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ValidationStatus } from '../abstractions/EAppValidation';
import { IAppValidationItem } from '../abstractions/IAppValidation';
import { DistributeDialog } from '../../appDetails/components/Distribute/DistributeDialog';

const useStyles = makeStyles({
  card: {
    width: "380px",
    height: "150px",
    boxSizing: "border-box",
    borderRadius: "4px"
  },
});

export const ValidationPublish: React.FC<{
  currentValidation: IAppValidationItem | null;
}> = ({ currentValidation }) => {
  const classes = useStyles();
  const intl = useIntl();
  const [isDistributeOpen, setDistributeOpen] = useState(false);


  const header = intl.formatMessage({
    defaultMessage: "Publish to your org",
    description: "Validation Publish Title"
  });

  if (!currentValidation) {
    return <CardSkeleton />
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        header={<Text weight="semibold">{header}</Text>}
      />
      <Text size={200}>
        <FormattedMessage
          defaultMessage="Make your app available to people in your org. Once approved by your IT admin, your app will be featured in the Teams Store under Built for your org."
          description="Validation Publish Description"
        />
      </Text>
      <div>
        {isDistributeOpen && <DistributeDialog
          isOpen={isDistributeOpen}
          onClose={() => { setDistributeOpen(false); }}
          appId={currentValidation.appId || ""}
        />}
        <Button
          appearance='primary'
          disabled={currentValidation.status !== ValidationStatus.Completed}
          onClick={() => { setDistributeOpen(true); }}
        >
          <FormattedMessage
            defaultMessage="Publish"
            description="Publish Button"
          />
        </Button>
      </div>
    </Card>
  );
}

const CardSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardHeader
        header={<SkeletonItem style={{ width: "30%" }} />}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <SkeletonItem style={{ width: "80%" }} />
        <SkeletonItem style={{ width: "50%" }} />
        <SkeletonItem style={{ width: "30%" }} />
      </div>
    </Card>
  )
}